<template lang="html">
    <div>
        <div class="flex" :class="labelFlexClass">
            <button
                :class="[
                    `vs-switch-${color}`,
                    {
                        'vs-switch-active': isChecked || $attrs.checked
                    }
                ]"
                :style="style"
                v-bind="$attrs"
                class="vs-component vs-switch"
            >
                <input
                    ref="inputCheckbox"
                    v-bind="$attrs"
                    :disabled="$attrs.disabled"
                    :value="value"
                    class="input-switch vs-switch--input"
                    type="checkbox"
                    v-on="listeners"
                />

                <span
                    ref="on"
                    :class="{ 'active-text': isChecked || $attrs.checked }"
                    class="text-on text-switch vs-switch--text"
                >
                    <slot name="on" />
                    <vs-icon
                        :icon-pack="iconPack"
                        :icon="iconOn || icon"
                        class="icons-switch vs-switch--icon ml-1"
                    />
                </span>
                <span
                    ref="off"
                    :class="{ 'active-text': !isChecked && !$attrs.checked }"
                    class="text-off text-switch vs-switch--text"
                >
                    <!-- gato con botas -->
                    <slot name="off" />
                    <vs-icon
                        :icon-pack="iconPack"
                        :icon="iconOff || icon"
                        class="icons-switch vs-switch--icon ml-1"
                    />
                </span>
                <span class="vs-circle-switch vs-switch--circle" />
            </button>
            <label v-if="label" class="vs-input--label" :class="labelClass" v-html="label" />
        </div>
        <vx-validation-message />
    </div>
</template>

<script>
import _color from '@/assets/utils/color.js'
import validationMixins from '@/plugins/validation/mixins.js'

export default {
    name: 'vx-switch',
    mixins: [validationMixins],
    inheritAttrs: false,
    props: {
        value: {
            type: Boolean,
            default: false
        },
        color: {
            default: 'primary',
            type: String
        },
        icon: {
            default: null,
            type: String
        },
        iconOn: {
            default: null,
            type: String
        },
        iconOff: {
            default: null,
            type: String
        },
        iconPack: {
            default: 'material-icons',
            type: String
        },
        label: {
            default: null,
            type: String
        },
        labelPosition: {
            type: String,
            default: 'right',
            validator: (v) => ['top', 'bottom', 'left', 'right'].contains(v)
        }
    },
    data: () => ({
        widthx: 42
    }),
    computed: {
        style() {
            return {
                background: this.value ? _color.getColorString(this.color, 1) : null,
                width: `${this.widthx}px`
            }
        },
        listeners() {
            return {
                ...this.$listeners,
                input: (evt) => {
                    this.toggleValue(evt)
                }
            }
        },
        labelFlexClass() {
            if (this.labelPosition === 'top') {
                return 'flex-col-reverse'
            } else if (this.labelPosition === 'bottom') {
                return 'flex-col'
            } else if (this.labelPosition === 'left') {
                return 'flex-row-reverse items-center pr-4'
            } else if (this.labelPosition === 'right') {
                return 'flex-row items-center'
            }
            return 'flex-row items-start'
        },
        labelClass() {
            if (this.labelPosition === 'left') {
                return 'pr-2'
            }
            return ''
        },
        isChecked: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    mounted() {
        this.startRefWatcher()
    },
    methods: {
        toggleValue(evt) {
            this.isChecked = !this.isChecked
        },
        startRefWatcher() {
            const intervalId = setInterval(() => {
                // Check if the ref is available

                // Perform the job when the ref is available
                let w = 0
                if (this.$refs.on && this.$refs.off) {
                    w =
                        this.$refs.on.clientWidth > this.$refs.off.clientWidth
                            ? this.$refs.on.clientWidth
                            : this.$refs.off.clientWidth
                    // Optionally, you can stop the watcher if the job is done
                    clearInterval(intervalId)
                }

                this.widthx = w + 29
            }, 200) // Check every 200th of a second
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/vuexy/components/vxSwitch.scss';
.vs-input--label {
    padding-left: 0;
}
</style>
